import { css, cx } from '@emotion/css';
import { Box } from '@repo/ui/atoms';
import CloseButton from '../common/CloseButton';
import QuestionTitle from '../common/QuestionTitle';
import { Study } from '../utils/fetchData';
import MultilineText from '../utils/MultilineText';
import { useStudyContext } from '../utils/StudyContext';
import { useTranslationsContext } from '../utils/TranslationsContext';

// TODO: Own package
// The keys in translations, "disqualifyTitle", "disqualifyDescription", "panelSignupSuccessDescription", "panelSignupSuccessTitle"

function getDisqualifyMessages(translations: Study['translations']) {
    const title = translations.find(
        (translation) => translation.key === 'disqualifyTitle',
    );
    const description = translations.find(
        (translation) => translation.key === 'disqualifyDescription',
    );
    return { title, description };
}

const DisqualifyMessage = () => {
    const { t } = useTranslationsContext();
    const { study } = useStudyContext();

    const { title, description } = getDisqualifyMessages(study.translations);

    return (
        <div style={{ paddingTop: 64 }}>
            <Box
                gap="8"
                justifyContent="center"
                alignItems="center"
                direction="column"
            >
                <QuestionTitle
                    label={
                        title?.value ??
                        t(`confirmationScreen.thanksForResponse`)
                    }
                    align="center"
                />
                {
                    <MultilineText
                        align="center"
                        text={
                            description?.value ??
                            t(
                                `confirmationScreen.thanksForYourResponseDescription`,
                            )
                        }
                    />
                }
            </Box>
            <div className={cx(CenterStyle, BottomStyle)}>
                <CloseButton />
            </div>
        </div>
    );
};

export default DisqualifyMessage;

const CenterStyle = css`
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    > * {
        text-align: center;
    }
`;

const BottomStyle = css`
    padding: 24px 0;
`;
